import { useTheme } from '@mui/material';

export default function BackButtonIcon() {
  const theme = useTheme();
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='16' cy='16' r='16' fill={theme.palette.primary.light} />
      <mask
        id='mask0_19968_91983'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='4'
        y='4'
        width='24'
        height='24'
      >
        <rect x='4' y='4' width='24' height='24' fill='#DA0808' />
      </mask>
      <g mask='url(#mask0_19968_91983)'>
        <path
          d='M23.1328 23.0976V19.4847C23.1328 18.5582 22.8155 17.7675 22.1808 17.1126C21.5463 16.4574 20.7803 16.1299 19.8828 16.1299H10.5058L14.3558 20.104L13.2866 21.1918L7.63281 15.3557L13.2866 9.51953L14.3558 10.6073L10.5058 14.5815H19.8828C21.1956 14.5815 22.3155 15.0599 23.2423 16.0168C24.1693 16.9736 24.6328 18.1295 24.6328 19.4847V23.0976H23.1328Z'
          fill={theme.palette.primary.main}
        />
      </g>
    </svg>
  );
}
